import { EDCOMP_EQN_MULTILINE, EDCOMP_TITLE, EDCOMP_EQUATION, EDCOMP_PARAG, EDCOMP_MULTI_EQUATION, EDCOMP_LIST } from "../../constants/frameConstants";



// Search through content items to find comment, return the comment and where it was.
export function retrieve_comment_by_comment_id(content, comment_id) {
    for (let c_section = 0; c_section< content.length; c_section++){
        let comment_index = content[c_section].comments.findIndex(el => {  return (el._id===comment_id)}); 
        if(comment_index!==-1)
            return {comment:content[c_section].comments[comment_index], content_index:c_section, comment_index:comment_index};
    }
    return undefined ; 
}

// Extract content from this particular frame from AI
function extract_content_for_ai(frame){

    let text = ""
    for(let c_content = 0; c_content < frame.contents.length; c_content++ ){
        switch(frame.contents[c_content].type){
            case EDCOMP_TITLE:
                var title_text =  frame.contents[c_content].title.replace(new RegExp("\\\\tag\\{(.*?)\\}","gm"), "$1 ")+"\n"                
                if (frame.contents[c_content].data.level==="chapter"){title_text = "# " + title_text}
                if (frame.contents[c_content].data.level==="section"){title_text = "## " + title_text}
                if (frame.contents[c_content].data.level==="subsection"){title_text = "### " + title_text}
                text = text+ title_text                
            break;
            case EDCOMP_PARAG:
                let parag_text = ""
                if(Object.hasOwn(frame.contents[c_content].data, 'paragraph_title'))
                {
                    parag_text = parag_text+ frame.contents[c_content].data.paragraph_title+" : "
                }
                parag_text = parag_text+frame.contents[c_content].data.text.replace(new RegExp("\\\\ref\\{[^\\}]+\\}\\{([^\\}]*)\\}","gm"), "$1")+"\n"
                text =text+ parag_text.replace(new RegExp("\\[(.+?)\\]\\(.+?\\)","gm"), "$1")
                break;
            case EDCOMP_EQUATION:
            case EDCOMP_EQN_MULTILINE:
                text = text+ frame.contents[c_content].data.equation + "\n"

            break; 
            case EDCOMP_MULTI_EQUATION:
                const equations = frame.contents[c_content].data.equation.split(";;;split;;;")
                const captions = frame.contents[c_content].data.text.split(";;;split;;;")
                for (var i = 0; i < equations.length; i++){
                    text = text+ captions[i]+"\n"
                    text = text+ equations[i] + "\n"
                }
            break;
            case EDCOMP_LIST:
                const list_items = frame.contents[c_content].data.text.split(";;;split;;;")
                for (var i = 0; i < list_items.length; i++){
                    text = text+ "-"+ list_items[i] +"\n"
                }
            break; 
            default:
        }
    }
    // console.log(text)
    return text 
}

// Find the current frame and call routine to extract content for AI
export function retrieve_nearby_text_content(content, frame_id){
    for (let c_section = 0; c_section< content.length; c_section++){
        for (let c_subsection = 0; c_subsection < content[c_section].subsections.length; c_subsection++){
            const frame = content[c_section].subsections[c_subsection].frames.filter(el => {return(el._id===frame_id)})
            if(frame.length > 0 ){
                const text_contents = extract_content_for_ai(frame[0]) ; 
                return text_contents
            }
        }
    }
    return "Failed"; 
}




// Extract content as latex
export function extract_latex(frame){

    let text = ""
    for(let c_content = 0; c_content < frame.contents.length; c_content++ ){
        switch(frame.contents[c_content].type){
            case EDCOMP_TITLE:
                var title_text =  frame.contents[c_content].title.replace(new RegExp("\\\\tag\\{(.*?)\\}","gm"), "")               
                if (frame.contents[c_content].data.level==="chapter"){title_text = "\\chapter{" + title_text+"}"}
                if (frame.contents[c_content].data.level==="section"){title_text = "\\section{" + title_text+"}"}
                if (frame.contents[c_content].data.level==="subsection"){title_text = "\\subsection{" + title_text+"}"}
                text = text+ title_text +"\n\n"               
            break;
            case EDCOMP_PARAG:
                let parag_text = ""
                if(Object.hasOwn(frame.contents[c_content].data, 'paragraph_title'))
                {
                    parag_text = parag_text+ "\\paragraph{"+ frame.contents[c_content].data.paragraph_title+" :} "
                }
                parag_text = parag_text+frame.contents[c_content].data.text.replace(new RegExp("\\\\ref\\{[^\\}]+\\}\\{([^\\}]*)\\}","gm"), "$1")+"\n"
                text =text+ parag_text.replace(new RegExp("\\[(.+?)\\]\\(.+?\\)","gm"), "$1") + "\n"
                break;
            case EDCOMP_EQUATION:
                text = text+ frame.contents[c_content].data.equation + "\n\n"
                break;
            case EDCOMP_EQN_MULTILINE:
                text = text+ frame.contents[c_content].data.equation + "\n\n"
            break; 
            case EDCOMP_MULTI_EQUATION:
                const equations = frame.contents[c_content].data.equation.split(";;;split;;;")
                const captions = frame.contents[c_content].data.text.split(";;;split;;;")
                for (var i = 0; i < equations.length; i++){
                    text = text+ captions[i]+"\n"
                    text = text+ equations[i] + "\n\n"
                }
            break;
            case EDCOMP_LIST:
                const list_items = frame.contents[c_content].data.text.split(";;;split;;;")
                text = text+"\\begin{itemize}"
                for (var i = 0; i < list_items.length; i++){
                    text = text+ "\\item "+ list_items[i] +"\n"
                }
                text = text+"\\end{itemize}"
            break; 
            default:
        }
    }

    text = text.replace(/\*(.*?)\*/g, '{\\em $1}');
    text = text.replace(new RegExp("\\\\tag\\{(.*?)\\}","gm"), "") 
    return text 
}